import { render, staticRenderFns } from "./ThemeCheckboxInput.vue?vue&type=template&id=12c5ffcc&scoped=true&"
import script from "./ThemeCheckboxInput.vue?vue&type=script&lang=js&"
export * from "./ThemeCheckboxInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c5ffcc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
